export default "__VITE_ASSET__51e6436d__"